import { LineRender } from "@visactor/vrender-core/render/symbol";

import { resolveContainerBinding } from "../../../common/explicit-binding";

import { CanvasLinePicker, CanvasPickerContribution } from "../constants";

import { DefaultCanvasLinePicker } from "./line-picker";

let loadLinePick = !1;

export function bindLineCanvasPickerContribution(container) {
    loadLinePick || (loadLinePick = !0, container.bind(CanvasLinePicker).toDynamicValue((() => new DefaultCanvasLinePicker(resolveContainerBinding(container, LineRender)))).inSingletonScope(), 
    container.bind(CanvasPickerContribution).toService(CanvasLinePicker));
}
//# sourceMappingURL=line-module.js.map
